module.exports = __webpack_public_path__ + "img/Play.7c2d8e3c.svg";